import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53038aa2")

_pushScopeId("data-v-53038aa2")
const _hoisted_1 = {
  class: "full_width",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = { style: {"margin-top":"20px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("场景：")
const _hoisted_4 = { class: "frames-num" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("画质：")
const _hoisted_6 = { class: "frames-num" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("对比数据版本：")
const _hoisted_9 = { class: "frames-num" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("纬度：")
const _hoisted_12 = { class: "frames-num" }
const _hoisted_13 = {
  class: "frames-num",
  style: {"margin-left":"10px"}
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("size：")
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("so：")
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("函数：")
const _hoisted_20 = { key: 5 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("so： ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_23 = {
  key: 0,
  width: "100%",
  id: "chart_funcitons",
  class: "chart-area flame_margin"
}
const _hoisted_24 = {
  key: 1,
  width: "100%",
  id: "chart_so",
  class: "chart-area flame_margin"
}
const _hoisted_25 = {
  key: 2,
  style: {"min-height":"800px"}
}
const _hoisted_26 = /*#__PURE__*/_createVNode("div", {
  width: "100%",
  id: "chart",
  class: "chart-area flame_margin"
}, null, -1)
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { style: {"display":"flex"} }
const _hoisted_29 = { class: "frames-info" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 增加堆栈数:")
const _hoisted_31 = { class: "frames-num" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("个, ")
const _hoisted_33 = { class: "frames-info" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 相同堆栈数:")
const _hoisted_35 = { class: "frames-num" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("个, ")
const _hoisted_37 = { class: "frames-info" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 减少堆栈数:")
const _hoisted_39 = { class: "frames-num" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_41 = /*#__PURE__*/_createVNode("div", {
  id: "merge",
  class: "chart-area flame_margin"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", null, [
        _hoisted_3,
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.scene), 1)
      ]),
      _createVNode("span", null, [
        _hoisted_5,
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.level), 1)
      ]),
      (_ctx.type.includes('merge'))
        ? (_openBlock(), _createBlock("span", _hoisted_7, [
            _hoisted_8,
            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.old_date_name), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'memory_xcode')
        ? (_openBlock(), _createBlock("span", _hoisted_10, [
            _hoisted_11,
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.dimension), 1),
            _createVNode("span", _hoisted_13, _toDisplayString(_ctx.option_memory), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'memory' || _ctx.type.includes('merge') || _ctx.type == 'memory_xcode')
        ? (_openBlock(), _createBlock("span", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_el_input, {
              style: {"width":"200px"},
              size: "mini",
              placeholder: "单位KB",
              modelValue: _ctx.size,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.size = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'memory' || _ctx.type.includes('merge') || _ctx.type == 'memory_xcode')
        ? (_openBlock(), _createBlock("span", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_el_select, {
              modelValue: _ctx.so_list,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.so_list = $event)),
              multiple: "",
              size: "mini",
              filterable: "",
              "collapse-tags": "",
              "collapse-tags-tooltip": "",
              placeholder: "请选择"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funcSoTrend, (item, k) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: k,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.type == 'func' ||
          _ctx.type == 'memory' ||
          _ctx.type.includes('merge') ||
          _ctx.type == 'memory_xcode'
        )
        ? (_openBlock(), _createBlock("span", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_el_input, {
              style: {"width":"500px"},
              size: "mini",
              modelValue: _ctx.funcList,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.funcList = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'so')
        ? (_openBlock(), _createBlock("span", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_el_select, {
              modelValue: _ctx.so,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.so = $event)),
              multiple: "",
              size: "mini",
              filterable: "",
              "collapse-tags": "",
              "collapse-tags-tooltip": "",
              placeholder: "请选择"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.so_list_data, (item, k) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: k,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        type: "primary",
        size: "mini",
        onClick: _ctx.confirm
      }, {
        default: _withId(() => [
          _hoisted_22
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.type == 'func')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 6,
            onClick: _ctx.check_view,
            size: "mini",
            type: "primary"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.changeView ? "相对视图" : "原始视图"), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.type == 'so')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 7,
            onClick: _ctx.check_view_so,
            size: "mini",
            type: "primary"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.changeViewSo ? "相对视图" : "原始视图"), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.type == 'memory' || _ctx.type == 'memory_xcode')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 8,
            onClick: _ctx.check_view_memory,
            size: "mini",
            type: "primary"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.changeViewMemory ? "相对视图" : "原始视图"), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.type == 'func')
      ? (_openBlock(), _createBlock("div", _hoisted_23))
      : _createCommentVNode("", true),
    (_ctx.type == 'so')
      ? (_openBlock(), _createBlock("div", _hoisted_24))
      : _createCommentVNode("", true),
    (_ctx.type == 'memory' || _ctx.type == 'memory_xcode')
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_25, [
          _hoisted_26
        ], 512)), [
          [_directive_loading, _ctx.flameLoading]
        ])
      : _createCommentVNode("", true),
    (_ctx.type.includes('merge'))
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("p", _hoisted_29, [
              _hoisted_30,
              _createVNode("span", _hoisted_31, _toDisplayString(_ctx.perfettoStack_v2?.increase?.count || _ctx.ios_perfettoStack_v2?.increase?.Count), 1),
              _hoisted_32
            ]),
            _createVNode("p", _hoisted_33, [
              _hoisted_34,
              _createVNode("span", _hoisted_35, _toDisplayString(_ctx.perfettoStack_v2?.tree?.count || _ctx.ios_perfettoStack_v2?.tree?.Count), 1),
              _hoisted_36
            ]),
            _createVNode("p", _hoisted_37, [
              _hoisted_38,
              _createVNode("span", _hoisted_39, _toDisplayString(_ctx.perfettoStack_v2?.decrease?.count || _ctx.ios_perfettoStack_v2?.decrease?.Count), 1),
              _hoisted_40
            ])
          ]),
          _hoisted_41
        ], 512)), [
          [_directive_loading, _ctx.flameLoadingStack]
        ])
      : _createCommentVNode("", true)
  ]))
})